module.exports = __webpack_public_path__ + "img/publications.e08fdcfe.gif";